"use client";

import { HomeTrackQuery, Track } from "@/lib/generated/graphql";
import { Suspense } from "react";
import LatestMixtapes from "./sections/latest-mixtapes";
import LatestMusic from "./sections/latest-music";
import LatestPublished from "./sections/latest-published";
import { SectionSkeleton } from "./sections/skeletons";
import TopViews from "./sections/top-views";

export function TrackMainCard({ track }: { track: HomeTrackQuery }) {

  return (
    <>
      <div className="container mx-auto px-4 py-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* 1️⃣ Section : Top vues */}
          {track.getTopViewedTracks?.length && (
            <Suspense fallback={<SectionSkeleton />}>
              <TopViews getTopViewedTracks={track.getTopViewedTracks} />
            </Suspense>
          )}
          {/* 2️⃣ Section : Dernières publications */}
          {track.getLatestPublishedTracks &&
            track.getLatestPublishedTracks?.length > 0 && (
              <Suspense fallback={<SectionSkeleton />}>
                <LatestPublished
                  getLatestPublishedTracks={
                    track.getLatestPublishedTracks as Track[]
                  }
                />
              </Suspense>
            )}
          {/* 3️⃣ Section : Dernières musiques */}
          {track.getLatestPublishedMusic &&
            track.getLatestPublishedMusic?.length > 0 && (
              <Suspense fallback={<SectionSkeleton />}>
                <LatestMusic
                  getLatestPublishedMusic={
                    track.getLatestPublishedMusic as Track[]
                  }
                />
              </Suspense>
            )}

          {/* 4️⃣ Section : Dernières mixtapes */}
          {track.getLatestPublishedMixtapes &&
            track.getLatestPublishedMixtapes?.length > 0 && (
              <Suspense fallback={<SectionSkeleton />}>
                <LatestMixtapes
                  getLatestPublishedMixtapes={
                    track.getLatestPublishedMixtapes as Track[]
                  }
                />
              </Suspense>
            )}
        </div>
      </div>
    </>
  );
}
